<template>
    <vs-card>
        <vs-table class="cstm_vuexy_table payroll_table" search :data="users">
            <template slot="thead">
                <vs-th sort-key="teacher">
                Teacher Name
                </vs-th>
                <vs-th sort-key="course">
                Course Name
                </vs-th>
                <vs-th sort-key="subject">
                Subject
                </vs-th>
                <vs-th sort-key="period">
                Period
                </vs-th>
                <vs-th sort-key="salary">
                Agreed Hourly Salary
                </vs-th>
                <vs-th sort-key="ghour">
                Guranteed Working hours
                </vs-th>
                <vs-th sort-key="totalHour">
                Total Working Hours
                </vs-th>
                <vs-th sort-key="payments">
                Type of Payments
                </vs-th>
                <vs-th sort-key="ddate">
                Due date
                </vs-th>
                <vs-th sort-key="amount">
                Total Amount
                </vs-th>
                <vs-th sort-key="status">
                Status
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                <vs-td :data="data[indextr].teacher">
                    {{data[indextr].teacher}}
                </vs-td>

                <vs-td :data="data[indextr].course">
                    {{data[indextr].course}}
                </vs-td>

                <vs-td :data="data[indextr].subject">
                    {{data[indextr].subject}}
                </vs-td>

                <vs-td :data="data[indextr].period">
                    {{data[indextr].period}}
                </vs-td>

                <vs-td :data="data[indextr].salary">
                    {{data[indextr].salary}}
                </vs-td>

                <vs-td :data="data[indextr].ghour">
                    {{data[indextr].ghour}}
                </vs-td>

                <vs-td :data="data[indextr].totalHour">
                    {{data[indextr].totalHour}}
                </vs-td>

                <vs-td :data="data[indextr].payments">
                    {{data[indextr].payments}}
                </vs-td>

                <vs-td :data="data[indextr].ddate">
                    {{data[indextr].ddate}}
                </vs-td>

                <vs-td :data="data[indextr].amount">
                    {{data[indextr].amount}}
                </vs-td>

                <vs-td :data="data[indextr].status">
                    <span class="cstm-status-badge" :class="data[indextr].status.toLowerCase()">{{data[indextr].status}}</span>
                </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </vs-card>
</template>

<script>
export default {
  name: 'payroll',
  data () {
    return {
      users:[
        {
          'id': 1,
          'teacher': 'Leanne Graham',
          'course': 'Piano Course',
          'subject': 'Piano',
          'period': '1 year',
          'salary': 10000,
          'ghour': '5 hours',
          'totalHour': '8 hours',
          'payments': 'Stripe',
          'ddate': '12-04-2021',
          'amount': 10000,
          'status': 'Paid'
        },
        {
          'id': 2,
          'teacher': 'John Doe',
          'course': 'Violin Course',
          'subject': 'Violin',
          'period': '1 year',
          'salary': 10000,
          'ghour': '6 hours',
          'totalHour': '9 hours',
          'payments': 'Debit Card',
          'ddate': '12-04-2021',
          'amount': 10000,
          'status': 'Paid'
        }
      ]
    }
  }
}
</script>
<style>
.cstm_vuexy_table thead th {
    background: #f3f2f7;
    border-top: 1px solid #ebe9f1;
    border-bottom: 2px solid #ebe9f1;
}
.cstm_vuexy_table thead th .vs-table-text {
    font-size: 11px;
    text-transform: uppercase;
}
.cstm_vuexy_table table td {
    border-top: 1px solid #ebe9f1;
}
</style>